import { Affix, Button, notification } from "antd";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import ShareModalContainer from "../../containers/ShareModalContainer/ShareModalContainer";
import {
  getFinalPriceFetching,
  getInfoValidation,
  getQuoteTotalPrice,
  getQuoteDiscountApplied,
} from "../../redux/QuoteSelectors";
import { getSupplierSettings } from "../../../../Redux/Selectors/appConfigSelector";
import { useSelector } from "react-redux";
import { getCurrencyConfig, renderPrice } from "../../../../helpers/tools";
import useIsMobile from "../../../../hooks/useIsMobile";
import { useTranslation } from "react-i18next";
import { DateOfBirthProvider } from "../../../../components/DateOfBirthSelector/context/DateOfBirthContext";
import DiscountInput from "../../../ShopPage/components/DiscountInput/DiscountInput";
import useQuoteDiscounts from "../../hooks/useQuoteDiscounts";

const Container = styled.div`
  width: 100%;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.borders.gray};
  height: 80px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 10px;
`;

const DiscountWrapper = styled.div`
  max-width: 300px;
  width: 100%;

  p {
    display: none;
  }
`;

const DiscountLabel = styled.span`
  color: ${({ theme }) => theme.colors.green};
  font-weight: bold;
  font-size: 14px;
  white-space: nowrap;
`;

const Footer = () => {
  const totalPrice = useSelector(getQuoteTotalPrice);
  const isMobile = useIsMobile();
  const { t } = useTranslation(["common", "shop"]);
  const isFetching = useSelector(getFinalPriceFetching);
  const settings = useSelector(getSupplierSettings);
  const [showModal, setShowModal] = useState(false);
  const isValidForm = useSelector(getInfoValidation);
  const discountApplied = useSelector(getQuoteDiscountApplied);
  const {
    handleApplyDiscount,
    handleRemoveDiscount,
    firstApplicationIntent,
  } = useQuoteDiscounts();

  const discountError = !discountApplied && firstApplicationIntent;
  const prevIsFetchingRef = useRef(isFetching);

  useEffect(() => {
    const wasFetching = prevIsFetchingRef.current;
    prevIsFetchingRef.current = isFetching;

    if (wasFetching && !isFetching && discountError) {
      notification.error({
        message: t("shop:invalidDiscountCode"),
      });
    }
  }, [isFetching, discountError]);

  const handleOnClick = () => {
    setShowModal(!showModal);
  };

  const discountsProps = {
    onApplyDiscount: handleApplyDiscount,
    onRemoveDiscount: handleRemoveDiscount,
    discountError: false,
  };

  return (
    <Affix offsetBottom={0}>
      <div>
        <Container>
          {discountApplied && (
            <DiscountLabel>
              {t("shop:discountAmount", {
                amount: discountApplied.amountDiscount,
              })}
            </DiscountLabel>
          )}
          {!isFetching && (
            <DiscountWrapper>
              <DiscountInput discount={discountApplied} {...discountsProps} />
            </DiscountWrapper>
          )}
          <Button
            type="primary"
            shape="round"
            block={isMobile}
            size="large"
            disabled={totalPrice === 0 || !isValidForm}
            onClick={handleOnClick}
          >
            {isFetching
              ? t("shop:summaryLoader")
              : `${t("continue")} | ${
                  getCurrencyConfig(settings.currency).symbol
                } ${renderPrice(totalPrice, settings.currency)}`}
          </Button>
        </Container>
        <DateOfBirthProvider>
          <ShareModalContainer showModal={showModal} onClose={handleOnClick} />
        </DateOfBirthProvider>
      </div>
    </Affix>
  );
};
export default Footer;
